import { gql } from "@apollo/client";
import { EVENT_FIELDS } from "../fragments";

export const CREATE_EVENT = gql`
  mutation createEvent(
    $title: String!
    $subtitle: String!
    $imageUrl: String!
    $bannerUrl: String!
    $url: String!
    $description: String!
    $eventDate: String!
    $tags: String
    $visible: Boolean
    $imageAttribute: ImageAttributeInput
    $nameAttribute: NameAttributeInput
  ) {
    createEvent(
      input: {
        title: $title
        subtitle: $subtitle
        imageUrl: $imageUrl
        bannerUrl: $bannerUrl
        url: $url
        description: $description
        eventDate: $eventDate
        tags: $tags
        visible: $visible
        imageAttribute: $imageAttribute
        nameAttribute: $nameAttribute
      }
    ) {
      ...EventFields
    }
  }
  ${EVENT_FIELDS}
`;
